import { render, staticRenderFns } from "./TrStaticText.vue?vue&type=template&id=d94ff300&scoped=true&"
import script from "./TrStaticText.vue?vue&type=script&lang=js&"
export * from "./TrStaticText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94ff300",
  null
  
)

export default component.exports